import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from '@app/shared/shared.module';
import { SalonsSearchResultsItemComponent } from '@app/salons-search-results/salons-search-results-item/salons-search-results-item.component';
import { SalonsSearchResultsComponent } from '@app/salons-search-results/salons-search-results/salons-search-results.component';
import localeNl from '@angular/common/locales/nl';

registerLocaleData(localeNl);
@NgModule({
  declarations: [
    SalonsSearchResultsComponent,
    SalonsSearchResultsItemComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BsDropdownModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'nl-NL' }
  ]
})
export class SalonsSearchResultsModule { }
